// SPDX-FileCopyrightText: 2019-2022 Matus Faro <matus@smotana.com>
// SPDX-License-Identifier: Apache-2.0
import { loadableReady } from '@loadable/component';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import ReactDOM from 'react-dom';
import { detectEnv, Environment, isProd } from './common/util/detectEnv';
import { getI18n } from './i18n-csr';
import Main from './Main';

// Suppress third-party library warnings and errors
const originalWarn = console.warn;
console.warn = (...args: any[]) => {
  const message = args[0];
  if (typeof message === 'string' && message.includes('React.createFactory()')) {
    return;
  }
  originalWarn.apply(console, args);
};

const originalError = console.error;
console.error = (...args: any[]) => {
  const message = args[0];
  if (message instanceof TypeError && message.message?.includes("can't redefine non-configurable property \"Worker\"")) {
    return;
  }
  if (typeof message === 'string' && message.includes("can't redefine non-configurable property \"Worker\"")) {
    return;
  }
  originalError.apply(console, args);
};

Sentry.init({
  dsn: "https://600460a790e34b3e884ebe25ed26944d@o934836.ingest.sentry.io/5884409",
  integrations: [new Integrations.BrowserTracing()],
  ignoreErrors:[
    'Non-Error exception captured',
    'Non-Error promise rejection captured',
  ],
  tracesSampleRate: !isProd() ? 1.0 : 0.1,
  replaysSessionSampleRate: !isProd() ? 1.0 : 0.1,
  replaysOnErrorSampleRate: !isProd() ? 1.0 : 0.1,
  environment: detectEnv(),
});

if (detectEnv() !== Environment.DEVELOPMENT_FRONTEND) {
  loadableReady(() => {
    ReactDOM.hydrate((<Main i18n={getI18n()} />), document.getElementById('mainScreen'));
  })
} else {
  ReactDOM.render((<Main i18n={getI18n()} />), document.getElementById('mainScreen'));
}
